import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ScrollService } from '../../../services/scroll.service';

@Component({
  selector: 'app-scroll-to-top',
  imports: [],
  templateUrl: './scroll-to-top.html',
  styleUrl: './scroll-to-top.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollToTop {
  public scrollService = inject(ScrollService);
}
